export const SUPER_ADMIN = "Super Admin";
export const ADMIN = "Sysadmin";
export const INSURANCE = "Insurance";
export const BANK = "Wilayah";
export const BANK_CABANG = "Bank Cabang";
export const WILAYAH = "Wilayah";
export const BANK_PUSAT = "Bank Pusat";
export const BROKER = "Broker";
export const ADMIN_REASURANSI = "Sysadmin Reasuransi";
export const REASURANSI = "Reasuransi";
export const USER_REINSURANCE = "USER_REINSURANCE";
